import { Injectable, inject } from '@angular/core';
import { AppLoggerService } from './app-logger.service';

export interface VersionInfo {
  version: string;
  commit: string;
  buildNumber: string;
  branch: string;
  env: string;
  buildDate: string;
}

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private logger = inject(AppLoggerService);

  info: VersionInfo | null = null;

  async load(): Promise<void> {
    try {
      const response = await fetch('assets/version.json', { cache: 'no-cache' });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      this.info = (await response.json()) as VersionInfo;

      this.logger.log('[CustomerWeb] versión desplegada', this.info);
    } catch {
      this.info = null;
    }
  }

  get label(): string {
    if (!this.info) {
      return '';
    }
    return `v${this.info.version} · ${this.info.commit} · ${this.info.env}`;
  }
}
